import React from "react";

const BeginnerAnalysisIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#667085"
      className="size-6"
      {...props}
    >
      {/* Open book base */}
      <path
        d="M12 6 C12 6 8 4 4 5 L4 19 C8 18 12 20 12 20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6 C12 6 16 4 20 5 L20 19 C16 18 12 20 12 20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Center spine */}
      <line x1="12" y1="6" x2="12" y2="20" strokeLinecap="round" />

      {/* Small rising arrow on right page — "growth for beginners" */}
      <polyline
        points="14.5,15 16,12.5 17.5,13.5 19,10.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
      />
    </svg>
  );
};

export default BeginnerAnalysisIcon;
